module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-5-b7d0347bce6d9f7a051edf59d1386040.png";